// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"7371":"38eb5ade981f322b","8047":"cd4a8b2535cf356b"}[chunkId] + ".css";
};